import store from '../redux/store';

export const UniversityStyles = () => {
    const settings = store.getState().widget.settings;
    const primary = settings && settings.primary_color ? settings.primary_color : '#222222';

    const secondary = settings && settings.secondary_color ? settings.secondary_color : '#222222';

    const preStyle = document.getElementById('custom-theme');
    if (preStyle) preStyle.parentNode.removeChild(preStyle);

    function hexToRgb(hex) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `${r}, ${g}, ${b}`;
    }

    // Todo: DON'T WRITE HERE !!! And move with var(--primary) or var(--secondary) to styles, if you need change names - change them, here should be left only root selector
    const newStyles = document.createElement('style');

    const rgbaValues = hexToRgb(primary);

    newStyles.id = 'custom-theme';
    newStyles.innerHTML = `
    :root {
      --primary: ${primary};
      --primary-rgb: ${rgbaValues};
      --secondary: ${secondary};
    }
    .search-input, .filter-button{
      border-color: ${primary} !important
    }
    .profile-view__chat-link-button{
      background-color: ${primary} !important;
    }
    .profile-view__chat-link-button:hover{
      background-color: white !important;
      color: ${primary} !important;
      border-color: ${primary} !important;
    }
    .content-education-text, .faq-education-text{
      background-color: ${primary};
    }
    .faq-question-title:hover{
      color: ${primary} !important;
    }
    input:focus{
      border-color: ${primary}
    }
    .search-icon, .filter-icon{
      fill: ${primary} !important
    }
    .widget-head-filter-btn{
      color: white !important;
      background-color: ${primary} !important;
      border-color: ${primary} !important
    }
    .widget-head-filter-btn.is-active{
      background-color: white;
    }
    .widget-head-filter-btn:hover, .widget-head-filter-btn:focus{
      background-color: ${secondary};
      border-color: ${secondary};
    }
    .search-sbm{
      color: ${primary};
      border-color: ${primary};
    }
    .search-sbm:hover{
      background-color: ${primary};
    }
    .chat-societies-items .tag-text:hover, .chat-societies-items .tag-text:focus,
    .profile-card .profile-info-tags-tag-v2:hover, .profile-card .profile-info-tags-tag-v2:focus,
    .profile-card .place-tag-v2:hover, .profile-card .place-tag-v2:focus,
    .profile-card .student-common-info-block-v2:hover, .profile-card .student-common-info-block-v2:focus,
    .profile-card .profile-view-name:hover, .profile-card .profile-view-name:focus{
      color: ${primary};
    }
    .profile-link{
      color: ${primary};
      border-color: ${primary};
    }
    .profile-link:hover{
      background-color: ${primary};
    }
    .chat-item-name, .profile-card .profile-view-name{
      color: ${secondary};
    }
    .chat-item-name:hover, .chat-item-name:focus, .profile-card .profile-view-name:hover, .profile-card .profile-view-name:focus{
      color: ${primary};
    }
    .map-icon path{
      fill: ${primary};
    }
    .chat-societies-name{
      color: ${primary};
    }
    .see-more::after{
      background-color: ${primary};
    }
    .see-more:hover::after{
      background-color: ${secondary};
    }
    .see-more-answers, .custom-university-text{
      color: ${primary};
    }
    .chevron-see-answers path, .custom-university-icon{
      fill: ${primary}
    }
    .radio-input:checked+.radio-text{
      background-color: ${primary};
      border-color: ${primary}
    }
    .reset-link{
      color: ${primary};
    }
    .sign-in-back-link{
      color: ${primary};
    }
    .notification-warning{
      color: ${primary};
    }
    .notification-element{
      color: ${primary};
    }
    .styles_react-code-input__CRulA > input:focus{
      border: 1px solid ${primary} !important;
      caret-color: ${primary} !important;
    }
    .resend-code-button{
      color: ${primary};
    }
    .resend-code-button:hover{
      color: ${primary};
      opacity: 0.7
    }
    .resend-code-button:focus{
      color: ${primary};
      opacity: 0.7
    }
    .step-back-button:focus{
      color: ${primary};
      opacity: 0.7
    }
    .resend-code-button:disabled{
      cursor: not-allowed;
    }
    .step-back-button>svg>path{
      fill: ${primary};
    }
    .step-back-button>svg>path:hover{
      fill: ${primary};
      opacity: 0.7
    }
    .msg-avatar-block.no-avatar-mode{
      background-color: ${primary};
    }
    .el-btn{
      background-color: ${primary};
      border-color: ${primary}
    }
    .el-btn:hover, .el-btn:focus{
      color: ${primary};
      border-color: ${primary}
    }
    .line-border{
       border: 0.1px solid ${primary}
    }
    .line-border-left{
       border-left: 1px solid ${primary}
    }
    .line-border-right{
       border-right: 1px solid ${primary}
    }
    .university-name{
       color: ${primary}
    }
    .close-optional-questions path, .back-from-second-step path{
       fill: ${primary}
    }
    .close-optional-questions:focus, .back-from-second-step:focus{
      fill: ${primary};
      opacity: 0.3;
      outline: 0
   }
    .faq-head-row > a:hover {
      color: ${primary}
    }
    .chat-back-btn:hover {
      color: ${primary}
    }
    .chat-back-btn:focus {
      color: ${primary};
      opacity: 0.4
    }
    .profile-info-icon path{
      fill: ${primary}
    }
    .student-year, .student-name{
      color: ${primary}
    }
    .profile-info__tags__tag{
      color: ${primary};
      border-color: ${primary}
    }
    .chat-member-popup .student-tag{
      color: ${primary};
      border-color: ${primary}
    }
    .back-to-home-tab-btn{
      background-color: ${primary};
      border-color: ${primary}
    }
    .back-to-home-tab-btn:hover{
      color: ${primary};
    }
    .text-not-exist-title, .profile-company-name span{
      color: ${primary};
    }
    .terms-link-color{
      color: ${primary};
    }
    .terms-link-color:hover{
      color: ${primary};
      opacity: 0.7
    }
    .terms-link-color:focus{
      outline: auto;
    }
    .terms-color{
      color: ${primary};
    }
    .user-avatar-t{
      background-color: ${primary};
    }
    .mod-my .msg-avatar-block, .personal-random-avatar{
      background-color: ${primary} !important;
    }
    .new-messages-icon path, .not-found-messages-icon path{
      fill: ${primary};
    }
    .messages-counter{
      border: solid 1px ${primary};
      color: ${primary};
    }
    .radio-label:focus-within{
      outline: auto;
      outline-color: ${primary}
    }
    .dropdown-custom .input-wrapper:focus-within{
      border-color: ${primary}
    }
    .dropdown__input__chevron-active > path {
      fill: ${primary}
    }
    .filter-modal-options.active {
      color: ${primary}
    }
    .dropdown-custom .menu-wrapper.menu-wrapper-open{
      border-color: ${primary}
    }
    .checkbox[type=checkbox]:focus + span {
      outline: auto;
      outline-color: ${primary};
      outline-offset: 2px;
      outline-width: 1px
    }
    .settings-static-text > input:focus{
      outline: auto;
      outline-color: ${primary};
      outline-offset: 2px;
      outline-width: 1px
    }
    .parent-icon{
      fill:${primary};
    }
    .group-chat-item{
      border-top: solid 18px ${primary} !important;
      border-bottom: solid 10px ${primary} !important;
    }
    .group-chat-head-name{
      color: ${primary};
    }
    .group-chat-bottom .group-chat-join-btn {
       background-color: ${primary};
    }
    .chat-title-text.active, .chats-title-text.active {
       color: ${primary} !important;
    }
    .chat-title-text.active:after, .chats-title-text.active:after {
       background-color: ${primary} !important;
    }
    .social-proof-amount>svg>path{
      fill: ${primary};
    }
    .social-proof-amount {
      color: ${primary};
    }
    .interaction-page .chat-back-btn svg {
      fill: ${primary};
    }
    .live-event-header-container-mobile .chat-back-btn svg {
      fill: ${primary};
    }
    .see-more-ambassadors{
      color: ${primary};
      border-color: ${primary}
    }
    .see-more-ambassadors:hover, .see-more-ambassadors:focus{
      color: ${primary};
      opacity: 0.7;
    }
    .user-name-brand {
      color: ${primary};
    }
    .ambassador-chat-name:hover {
      color: ${secondary}
    }
    .ambassador-chat-name-header:hover {
      color: ${primary}
    }
    .leave-conversation:hover svg path, .share-chat-link:hover svg path {
      fill: ${primary}
    }
    .filter-modal-buttons-container > button {
      color: white;
      border: 1px solid ${primary};
      background-color: ${primary};
    }
    .filter-modal-buttons-container > button:active {
      color: white;
      border-color:${primary};
    }
    .filter-modal-buttons-container > button:first-child {
      background-color: white;
      color: ${primary};
    }
    .filter-modal-buttons-container > button:hover{
      background-color: ${primary} !important;
      border-color: ${primary};
      color: white !important;
    }
    .filter-modal-buttons-container > button:focus{
      background-color: ${primary};
      border-color: ${primary};
    }
    .filter-modal-buttons-container > button:first-child:hover{
      background-color: white;
      color: ${primary};
    }
    .filter-modal-buttons-container > button:first-child:focus{
      background-color: white;
      color: ${primary};
    }
    .member-icon-block{
      color: ${primary};
    }
    .member-icon-block svg path{
      fill: ${primary};
    }
    .members-scroll-block svg.active-chevron path{
      fill: ${primary};
    }
    .feedback-score:hover, .feedback-score.active{
      color: ${primary} !important;
    }
    .feedback-score:after{
      border-bottom: 10px solid ${primary} !important;
    }
    .sa-feedback-button-active svg path{
      fill: ${primary} !important;
    }
    .feedback-success-modal span{
      color: ${primary};
    }
    .participants-btn{
      color: ${primary};
    }
    .join-row svg {
      fill: ${primary}
    }
    .report-reason-popover-text {
      color: ${primary};
    }
    .report-reason-popover-text:hover {
      opacity: 0.7
    }
    .blocked-text {
      color: ${primary};
    }
    .live-event-registered-popup-text span {
      color: ${primary};
    }
    .show-more-less > button {
      color: ${primary};
    }
    .live-event-show-more-text {
      color: ${primary};
    }
    .live-event-join-block {
      border-color: ${primary};
    }
    .live-event-join-block span {
      color: ${primary};
    }
    .live-event-join-block svg {
      fill: ${primary}
    }
    .live-event-users-list .ant-tabs-bar .ant-tabs-tab-active{
      color: ${primary};
    }
    .live-event-users-list .ant-tabs-bar .ant-tabs-ink-bar {
      background-color: ${primary};
    }
    .profile-view-chat-link-button {
      background-color: ${primary} !important;
    }
    .profile-view-chat-link-button:hover {
      background-color: white !important;
      color: ${primary} !important;
      border-color: ${primary} !important;
      text-decoration: none !important;
    }
    .profile-view-chat-link-button:hover svg path {
      fill: ${primary} !important;
    }
    .join-event-btn.ant-btn-primary, .show-event-chat-btn.ant-btn-primary, .primary-btn.ant-btn-primary {
      border-color: ${primary} !important;
      background-color: ${primary} !important;
    }
    .link-btn.ant-btn-link {
      color: ${primary};
    }
    .primary-btn.ant-btn-primary:hover, .link-btn.ant-btn-link:hover {
      opacity: 0.7
    }
    .modal-select > .ant-select-focused .ant-select-selection, .modal-select > .ant-select-selection:focus, .modal-select > .ant-select-selection:active {
      border-color: ${primary};
      box-shadow: none
    }
    .modal-select > .ant-select-selection:hover, .modal-select > .ant-select-selection:active{
      border-color: ${primary};
    }
    .tap-event-stream-join-overlay .ant-btn-primary, .tap-event-stream .ant-modal-root .ant-btn-primary {
      border-color: ${primary};
      background-color: ${primary};
    }
    .forum-chat-join-btn {
      background-color: ${primary};
    }
    `;
    return newStyles;
};
